import { render } from "./vuestic-logo-no-notice.vue?vue&type=template&id=bbca3f74&scoped=true"
import script from "./vuestic-logo-no-notice.vue?vue&type=script&lang=js"
export * from "./vuestic-logo-no-notice.vue?vue&type=script&lang=js"

import "./vuestic-logo-no-notice.vue?vue&type=style&index=0&id=bbca3f74&scoped=true&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbca3f74"]])

export default __exports__